import { render, staticRenderFns } from "./PageAdminEvaluationGrid.vue?vue&type=template&id=0d191cd8"
import script from "./PageAdminEvaluationGrid.vue?vue&type=script&lang=js"
export * from "./PageAdminEvaluationGrid.vue?vue&type=script&lang=js"
import style0 from "./PageAdminEvaluationGrid.vue?vue&type=style&index=0&id=0d191cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports